import axios from "axios";
import { getAllEventMasterDetails } from "../server/Api";  // adjust path if needed

export const getAllEvents = async () => {
  try {
    const response = await axios.get(getAllEventMasterDetails());
    const payload = response.data;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error; // let caller handle errors
  }
};
